import { FiscalResponse } from '../services/viva/interfaces/fiscalResponse.interface';
import { ErrorCodeResponse } from './shared.interface';

// `ErrorCodeResponse` is composed on, not part of Viva's own contract - the server
// (`VivaProviderService.getSaleState()`) sets `errorCode` when a known AADE validation error is
// detected inside `message`, so the generic `errorCode`-driven toast handling (`api.ts`) can render
// a specific message instead of the raw Viva string.
export interface VivaSessionResponse extends VivaSessionInProgress, ErrorCodeResponse {
  sessionId: string;
  terminalId: string;
  cashRegisterId: string;
  amount: number;
  currencyCode: string;
  merchantReference: string | null;
  customerTrns: string | null;
  showReceipt: boolean | null;
  showTransactionResult: boolean | null;
  tipAmount: number;
  success: boolean;
  eventId: number;
  authorizationId: string | null;
  transactionId: string | null;
  transactionTypeId: string | null;
  retrievalReferenceNumber: string | null;
  panEntryMode: string;
  applicationLabel: string | null;
  aid: string | null;
  primaryAccountNumberMasked: string | null;
  transactionDateTime: string | null;
  abortOperation: boolean;
  abortAckTime: string | null;
  abortSuccess: boolean;
  loyaltyInfo: any | null;
  verificationMethod: string | null;
  tid: string;
  shortOrderCode: string;
  installments: number;
  message: string;
  preauth: boolean;
  referenceNumber: number;
  orderCode: string;
  transactionEventId: number;
  cardType: string | null;
  bankId: string | null;
  isvDetails: {
    amount: number;
    merchantId: string | null;
    sourceCode: string | null;
    merchantSourceCode: string | null;
  };
  aadeTransactionId: string | null;
  aadeResultCommand: string | null;
  dccDetails: any | null;
  surchargeAmount: number | null;
  fiscalisationDetails: FiscalResponse | null;
}

export enum VIVA_SESSION_DETAIL_MESSAGE {
  IN_PROGRESS = 'The session is being processed',
}

interface VivaSessionInProgress {
  detail: VIVA_SESSION_DETAIL_MESSAGE;
}
